import { useState } from 'react';
import { ActionButton } from '../../../components/action-button';
import { Modal } from '../../../components/modal';
import { CheckboxInput } from '../../../components/checkbox-input';
import { ButtonsRow, CheckboxWrapper } from './style';

export type UserFilterOptions = {
  driversOnly: boolean;
  nonDriversOnly: boolean;
};

type FilterUsersModalProps = {
  activeOptions: UserFilterOptions;
  onSaveClick: (options: UserFilterOptions) => void;
  onCancel: () => void;
};

export const FilterUsersModal = ({
  activeOptions,
  onSaveClick,
  onCancel,
}: FilterUsersModalProps) => {
  const [isDriversOnlyChecked, setDriversOnlyChecked] = useState(activeOptions.driversOnly);
  const [isNonDriversOnlyChecked, setNonDriversOnlyChecked] = useState(
    activeOptions.nonDriversOnly,
  );

  const handleDriversOnlyCheck = () => {
    setDriversOnlyChecked(!isDriversOnlyChecked);
    setNonDriversOnlyChecked(false);
  };

  const handleNonDriversOnlyCheck = () => {
    setNonDriversOnlyChecked(!isNonDriversOnlyChecked);
    setDriversOnlyChecked(false);
  };

  const handleSaveClick = () => {
    onSaveClick({
      driversOnly: isDriversOnlyChecked,
      nonDriversOnly: isNonDriversOnlyChecked,
    });
  };

  return (
    <Modal title="סינון משתמשים" isVisible onClose={onCancel}>
      <form
        onSubmit={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleSaveClick();
        }}
      >
        <CheckboxWrapper>
          <CheckboxInput
            isChecked={isDriversOnlyChecked}
            label="נהגים בלבד"
            onToggleCheck={handleDriversOnlyCheck}
          />
        </CheckboxWrapper>

        <CheckboxWrapper>
          <CheckboxInput
            isChecked={isNonDriversOnlyChecked}
            label="ללא נהגים"
            onToggleCheck={handleNonDriversOnlyCheck}
          />
        </CheckboxWrapper>

        <ButtonsRow>
          <ActionButton title="שמירה" type="submit" />
          <ActionButton title="ביטול" onClick={onCancel} kind="secondary" />
        </ButtonsRow>
      </form>
    </Modal>
  );
};
